module.exports = __webpack_public_path__ + "static/img/zhongzhongka12.fdbf648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka12.png
// module id = pPVp
// module chunks = 16